module.exports = __webpack_public_path__ + "img/angang.79b11fd4.jpg";